import React from 'react';
import PropTypes from 'prop-types';
import ReactStars from 'react-rating-stars-component';
import { FaMapMarkerAlt, FaGoogle } from 'react-icons/fa';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import { useUserData } from 'hooks/UserContext';
import { getAgesMessageToShow } from 'utils/schools/schoolFunctions';
import { useSchool } from '../../pages/SchoolProfile/SchoolContext';
import { getMiniCardData } from '../../pages/SchoolProfile/utils';
import miniCardConstants from './miniCardConstants';
import minicardStyles from './MiniCardStyles.module.css';

const MiniCard = ({ isFetching, positioning }) => {
  const { schoolData } = useSchool();
  const { appLanguage: lan } = useUserData();
  const miniCard = getMiniCardData(schoolData || {});
  const {
    neighborhood,
    city,
    logo,
    name,
    verified,
    address,
    rating,
    schoolManagement,
    schedules,
    userRatingsQty,
    placeId,
  } = miniCard || {};

  if (isFetching) {
    return <>...cargando </>;
  }

  const getGoogleMapsUrl = () => {
    if (!placeId) return null;
    return `https://www.google.com/maps/place/?q=place_id:${placeId}`;
  };

  const googleMapsUrl = getGoogleMapsUrl();

  return (
    <div
      className={minicardStyles.miniCard__card}
      style={{ marginLeft: typeof positioning === 'number' ? `${positioning}px` : undefined }}
    >
      <div className={minicardStyles.miniCard__firstRow}>
        <img src={logo || 'https://vacanted-schools-dev.s3.us-east-1.amazonaws.com/common/logo_empty_small.png'} alt="logo del centro" />
        <div className={minicardStyles.miniCard__content}>
          <p className={minicardStyles.mainCard__heading}>{name}</p>
          <p className={minicardStyles.mainCard__subHeading}>
            {`${schoolManagement?.name} de Educación ${getAgesMessageToShow(schedules)}`}
          </p>
          <p className={minicardStyles.locations}>
            <span>
              <FaMapMarkerAlt size={17} color="#36a7eb" />
              {' '}
              {`${address}, ${neighborhood?.name}, ${city?.name}`}
            </span>
          </p>
          {googleMapsUrl && (
            <div className={minicardStyles.miniCard__ratings}>
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={minicardStyles.ratings__link}
                aria-label={`Ver reseñas de ${name} en Google Maps`}
              >
                <ReactStars
                  size={17}
                  half={false}
                  value={Number(rating) || undefined}
                  edit={false}
                  classNames={{
                    star: minicardStyles.rating__star,
                  }}
                />
                <p>{`(${userRatingsQty}) reseñas en`}</p>
                <FaGoogle className={minicardStyles.google__icon} />
              </a>
            </div>
          )}
        </div>
      </div>
      {!!verified && (
        <div className={minicardStyles.miniCard__secondRow}>
          <div className={minicardStyles.verifiedMsg__container}>
            <p className={minicardStyles.verifiedMsg}>
              {miniCardConstants.verifiedInstitucionMsg[lan]}
            </p>
            <RiCheckboxCircleFill size={30} color="#0096ed" />
          </div>
        </div>
      )}
    </div>
  );
};

MiniCard.defaultProps = {
  vacantestCoords: {
    latitude: 0,
    longitude: 0,
  },
};

MiniCard.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  positioning: PropTypes.number.isRequired,
  vacantestCoords: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
};

export default MiniCard;
